import { useState } from "react";

export const useCityAutocomplete = () => {
  const [options, setOptions] = useState<Array<string>>([]);
  const [loading, setLoading] = useState(false);

  const fetchCities = async (input: string) => {
    if (!input) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/autocomplete/citystate?input=${input}`
      );
      const data = await response.json();
      setOptions(data.predictions.map((p: any) => p.description));
    } catch (error) {
      console.error("Failed to fetch cities:", error);
    } finally {
      setLoading(false);
    }
  };

  return { options, loading, fetchCities };
};

export interface AddressOption {
  description: string;
  place_id: string;
}

export const useAddressAutocomplete = (city?: string, state?: string) => {
  const [addressOptions, setOptions] = useState<Array<AddressOption>>([]);
  const [loadingAddress, setLoading] = useState(false);

  const fetchAddresses = async (input: string) => {
    if (!input) return;
    setLoading(true);
    try {
      const params = new URLSearchParams({
        input,
        ...(city && { city }),
        ...(state && { state }),
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/autocomplete/address?${params}`
      );
      const data = await response.json();
      setOptions(data.predictions.map((p: any) => p.description));
    } catch (error) {
      console.error("Failed to fetch addresses:", error);
    } finally {
      setLoading(false);
    }
  };

  return { addressOptions, loadingAddress, fetchAddresses };
};
